import { IconProps } from '@chakra-ui/react';
import React from 'react';
import { PlatformConnectType } from '~/components/PlatformConnect';
import { SOCIAL_PLATFORMS } from '~/constants';

export interface NameAndPlatformValues {
  name: string;
  platforms: SOCIAL_PLATFORMS[];
}

export type NameAndPlatformConnection = {
  [key in SOCIAL_PLATFORMS]: {
    icon: React.FC<IconProps>;
    component: PlatformConnectType;
  };
};
